import React, { useState } from "react";
import { Drawer } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Grid,
  Typography,
  Avatar,
  IconButton,
  Button,
  Radio,
  InputLabel,
  MenuItem,
} from "@mui/material";
import { IoMdClose } from "react-icons/io";
import CustomInput from "../Common/CustomInput";
import CustomSelect from "../Common/CustomSelect";
import { useMutation, useQuery } from "@apollo/client";
import { GET_ADMIN_PERMISSIONS } from "../../Utils/Queries";
import { CREATE_ROLE } from "../../Utils/Mutation";
import Loader from "../Common/Loader";
import { useSnackbarHook } from "../../hooks/useSnackbarHook";


const useStyles = makeStyles((theme) => ({
  drawer: {
    width: 540,
    flexShrink: 0,
    p: 4,
  },
  drawerPaper: {
    width: 540,
    p: 4,
  },
  toolbar: theme.mixins.toolbar,
}));
const CreateRole = ({ open, onClose }) => {
  const classes = useStyles();
 const [title, setTitle] = useState("")
  

  const { data, loading } = useQuery(GET_ADMIN_PERMISSIONS);

  const [createRole, {loading:createLoading}] = useMutation(CREATE_ROLE);

    const {handleClick} = useSnackbarHook()
    

  const handleCreateRole = async () =>{
    await createRole({
      variables:{
        title:title,
        description:"",
        permissionIds:selectedFeatureIds
      }

    }).then((res)=>{
 
      handleClick("Role Created Successfully", "success")
      onClose()
    }).catch((err)=>{
 handleClick(`${err.message}`, "error")
    })
  }

  const [selectedFeatureIds, setSelectedFeatureIds] = useState([]);

  const handleSelect = (featureId) => {
    setSelectedFeatureIds(
      (prev) =>
        prev.includes(featureId)
          ? prev.filter((id) => id !== featureId) // remove if already selected (toggle)
          : [...prev, featureId] // add if not selected
    );
  };



  return (
    <Drawer
      className={classes.drawer}
      anchor="right"
      open={open}
      onClose={onClose}
      classes={{ paper: classes.drawerPaper }}
    >
    {
      (createLoading || loading) && <Loader/>
    }
      <Box sx={{ px: 4, py: 5 }} className={classes.toolbar}>
        <Box sx={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
           <Typography
          sx={{
            fontFamily: "Lato",
            color: "#0D0D0D",
            fontSize: "20px",
            fontWeight: 700,
          
         
          }}
        >
          Create Role
        </Typography>
          <IconButton onClick={onClose}>
            <IoMdClose style={{ fontSize: "20px", color: "#000" }} />
          </IconButton>
        </Box>
     

        <Box sx={{ mt: 6 }}>
      
          <Box sx={{ mt: 2 }}>
            <CustomInput required label="Title" value={title} onChange={(e)=>setTitle(e.target.value)} />
          </Box>

          <Box sx={{ mt: 3 }}>
            <Typography sx={{fontWeight:500}}>Select Features</Typography>
            <Typography sx={{fontSize:'12px'}}>Choose one or more features to assign permissions.</Typography>
            <Box sx={{ mt: 2 }}>
              {data?.getAdminPermissions?.map((item, index) => (
                <MenuItem
                  onClick={() => handleSelect(item._id)}
                  key={index}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    columnGap: 2,
                    backgroundColor: selectedFeatureIds.includes(item._id)
                      ? "#f0f0f0"
                      : "transparent",
                  }}
                >
                  <Radio checked={selectedFeatureIds.includes(item._id)} />
                  <Typography>{item.feature}</Typography>
                </MenuItem>
              ))}
            </Box>
          </Box>

          <Button onClick={handleCreateRole} variant="contained" fullWidth sx={{ mt: 4, mb:4, borderRadius:'50px', height:'50px' }}>
           Create Roles
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};
export default CreateRole;
